import React from 'react';
import { useTranslation } from 'react-i18next';

import { dataDeletionUrl, legalUrl } from '@/nova/config/websiteUrls';
import { Bullet, LegalFooter, LegalLink, LinkLabel } from './LegalLinks.styles';

/**
 * The public legal / data-request links shown beneath the settings list: Privacy Policy ·
 * Terms & Conditions · Data Deletion. Each is a 48px touch target with 14px copy; both the link
 * colour and the middle-dot separators come from the themed tokens, so the footer reads correctly
 * in light and dark. `useTranslation` keeps the hrefs reactive to the live language switch, so they
 * point at the locale-appropriate whitelabels.com pages (Privacy Policy and Data Deletion are the
 * same destinations linked from the register screen; see `@/nova/config/websiteUrls`).
 */
export const LegalLinks = (): React.ReactElement => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;

  return (
    <LegalFooter aria-label={t('Legal')}>
      <LegalLink href={legalUrl(language, 'privacy-policy')} target="_blank" rel="noopener noreferrer">
        <LinkLabel text="Privacy Policy" tag="span" />
      </LegalLink>
      <Bullet aria-hidden="true">·</Bullet>
      <LegalLink href={legalUrl(language, 'terms-of-use')} target="_blank" rel="noopener noreferrer">
        <LinkLabel text="Terms & Conditions" tag="span" />
      </LegalLink>
      <Bullet aria-hidden="true">·</Bullet>
      <LegalLink href={dataDeletionUrl(language)} target="_blank" rel="noopener noreferrer">
        <LinkLabel text="Data Deletion" tag="span" />
      </LegalLink>
    </LegalFooter>
  );
};

export default LegalLinks;
